<template>
  <v-menu bottom offset-y transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-btn v-if="ghost" :class="`mx-2 unset-capitalize ${buttonClass}`" color="marca-0-l40" :disabled="disabled" :loading="localLoading" text v-on="on">
        <mf-icon class="mr-2" :color="disabled ? 'cinza-l60' : 'marca-0-l40'" fill size="20">download</mf-icon>
        {{ buttonLabel }}</v-btn
      >
      <v-btn v-else :class="`btn-export ${buttonClass}`" color="primary" :disabled="disabled" :loading="localLoading" v-on="on"> Exportar </v-btn>
    </template>
    <v-list>
      <v-list-item @click="exportCsv">
        <v-list-item-title class="menu-export-item"
          ><mf-icon color="cinza-d20" small>draft</mf-icon> <span class="cinza-d10-text">Exportar .csv</span></v-list-item-title
        >
      </v-list-item>
      <v-list-item v-if="!disableXLSX" @click="exportXlsx">
        <v-list-item-title class="menu-export-item"
          ><mf-icon color="cinza-d20" small>view_list</mf-icon> <span class="cinza-d10-text">Exportar .xlsx</span></v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { createCsvFromArray } from '@/helpers/csv.js'
import * as XLSX from 'xlsx'

export default {
  name: 'ExportData',
  props: {
    dataFetcher: Function,
    filename: String,
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: 'Exportar dados',
    },
    ghost: {
      type: Boolean,
      default: false,
    },
    async: {
      type: Boolean,
      default: false,
    },
    disableXLSX: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    lazyLoading: false,
  }),
  computed: {
    localLoading: {
      set(value) {
        this.lazyLoading = value
      },
      get() {
        return this.loading || this.lazyLoading
      },
    },
  },
  methods: {
    async exportCsv() {
      this.localLoading = true
      try {
        if (this.async) {
          this.$emit('file-format', 'csv')
        } else {
          const data = await this.dataFetcher()
          createCsvFromArray(data.rows, this.formatFileName(this.filename), data.headers)
        }
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao exportar .csv', snackbarColor: 'error' })
      }
      this.localLoading = false
    },
    async exportXlsx() {
      this.localLoading = true
      try {
        if (this.async) {
          this.$emit('file-format', 'xlsx')
        } else {
          const data = await this.dataFetcher()
          const worksheet = XLSX.utils.aoa_to_sheet([data.headers, ...data.rows])
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
          XLSX.writeFile(workbook, `${this.formatFileName(this.filename)}.xlsx`)
        }
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao exportar .xlsx', snackbarColor: 'error' })
      }
      this.localLoading = false
    },
    formatFileName(name) {
      return name.trim().replaceAll(' ', '_').toLowerCase()
    },
  },
}
</script>

<style lang="scss">
.cinza-d10-text {
  color: $cinza-d10;
  font-weight: 400;
  font-size: 14px;
  gap: 6px;
}

.menu-export-item {
  display: flex;
  gap: 6px;
}

.v-menu__content {
  border-radius: 8px;
}

.v-list-item {
  min-height: 40px;
}

.unset-capitalize {
  text-transform: unset !important;
  letter-spacing: $letterspacing-1;
}
</style>
